module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getBlockModifiers()
  }, [_c('img', {
    class: [_vm.block] + '-image',
    attrs: {
      "src": _vm.src,
      "alt": _vm.alt
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block] + '-caption'
  }, [_vm._v(_vm._s(_vm.data.caption))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ebbd682","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/Image.vue
// module id = 603
// module chunks = 0